/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftPattern } from './ShiftPattern';
import {
    ShiftPatternFromJSON,
    ShiftPatternFromJSONTyped,
    ShiftPatternToJSON,
} from './ShiftPattern';

/**
 * 
 * @export
 * @interface InspectionScheduleResponse
 */
export interface InspectionScheduleResponse {
    /**
     * 
     * @type {string}
     * @memberof InspectionScheduleResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionScheduleResponse
     */
    templateId?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionScheduleResponse
     */
    machineId?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionScheduleResponse
     */
    frequency?: InspectionScheduleResponseFrequencyEnum;
    /**
     * 
     * @type {string}
     * @memberof InspectionScheduleResponse
     */
    cronExpression?: string;
    /**
     * 
     * @type {ShiftPattern}
     * @memberof InspectionScheduleResponse
     */
    shiftPattern?: ShiftPattern;
    /**
     * 
     * @type {string}
     * @memberof InspectionScheduleResponse
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionScheduleResponse
     */
    endDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InspectionScheduleResponse
     */
    active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof InspectionScheduleResponse
     */
    lastGeneratedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InspectionScheduleResponse
     */
    nextGenerationAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InspectionScheduleResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InspectionScheduleResponse
     */
    updatedAt?: Date;
}


/**
 * @export
 */
export const InspectionScheduleResponseFrequencyEnum = {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    PerShift: 'PER_SHIFT',
    Custom: 'CUSTOM'
} as const;
export type InspectionScheduleResponseFrequencyEnum = typeof InspectionScheduleResponseFrequencyEnum[keyof typeof InspectionScheduleResponseFrequencyEnum];


/**
 * Check if a given object implements the InspectionScheduleResponse interface.
 */
export function instanceOfInspectionScheduleResponse(value: object): value is InspectionScheduleResponse {
    return true;
}

export function InspectionScheduleResponseFromJSON(json: any): InspectionScheduleResponse {
    return InspectionScheduleResponseFromJSONTyped(json, false);
}

export function InspectionScheduleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionScheduleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'frequency': json['frequency'] == null ? undefined : json['frequency'],
        'cronExpression': json['cronExpression'] == null ? undefined : json['cronExpression'],
        'shiftPattern': json['shiftPattern'] == null ? undefined : ShiftPatternFromJSON(json['shiftPattern']),
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'active': json['active'] == null ? undefined : json['active'],
        'lastGeneratedAt': json['lastGeneratedAt'] == null ? undefined : (new Date(json['lastGeneratedAt'])),
        'nextGenerationAt': json['nextGenerationAt'] == null ? undefined : (new Date(json['nextGenerationAt'])),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function InspectionScheduleResponseToJSON(value?: InspectionScheduleResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'templateId': value['templateId'],
        'machineId': value['machineId'],
        'frequency': value['frequency'],
        'cronExpression': value['cronExpression'],
        'shiftPattern': ShiftPatternToJSON(value['shiftPattern']),
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'active': value['active'],
        'lastGeneratedAt': value['lastGeneratedAt'] == null ? undefined : ((value['lastGeneratedAt']).toISOString()),
        'nextGenerationAt': value['nextGenerationAt'] == null ? undefined : ((value['nextGenerationAt']).toISOString()),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

